const mbti = {
  modal: {
    button: {
      close: 'スキップ',
      submit: '送信',
      newFavorites: {
        close: 'キャンセルする',
        submit: 'リストを作成'
      },
      existingFavorites: {
        close: '閉じる',
        viewFavorites: 'お気に入りリストを見る'
      },
      bookWithOtherTrainers: '他のトレーナーでレッスン予約',
      bookInMyBizmates: 'レッスン予約ページへ'
    }
  },
  trainer: {
    lessonCount: '{0}回'
  },
  trainerProfile: {
    booking: {
      schedule: 'レッスン日時',
      trainer_audio: 'トレーナーからのメッセージ',
      programType: 'レッスンタイプ教材',
      lessonMode: 'レッスン受講方法',
      discoveryId: '教材記事番号'
    },
    header: 'トレーナープロフィール',
    tabMenu: {
      profile: 'プロフィール',
      timeSettings: 'レッスン予約'
    },
    table: {
      trainerName: 'トレーナー名',
      lesson_count: '過去の受講回数',
      last_lesson_date: '直近の受講日',
      vote_average: 'トレーナー評価',
      characteristics: 'トレーナーの特徴',
      category: '大学専攻科目',
      career: 'ビジネス経験',
      japanese: '日本語の理解',
      self_introduction: '自己紹介',
      ticket_type: 'チケットタイプ'
    },
    self_introduction_jp: '事務局からのコメント',
    notes: {
      vote_average: '（ご自身がこのトレーナーで受講したレッスンの平均評価）'
    },
    explain1: 'お気に入りリストに登録すると、「レッスン予約」画面の先頭に優先表示されます。',
    explain2: 'プレイヤーの再生ボタンをクリックしてトレーナーの英語の自己紹介をお聴きください。',
    profileNote: 'メモ',
    memoPlaceholder: 'トレーナーに関するメモとしてご利用ください。',
    registerMemo: 'メモを登録',
    editMemo: 'メモを編集',
    noteError: '半角5000文字(全角2500文字、改行・空白含む)以内でご入力ください。'
  },
  timeSettings: {
    weeklyScheduleLabel: '週間スケジュール',
    scheduleNote: '予約可能レッスン数 ：残り',
    ticketCount: '{0}回',
    ticketInfo: '（通：{0} 振：{1}）'
  },
  evaluation: {
    header: 'トレーナーの評価をお願いいたします',
    subheader: 'トレーナーについての評価',
    description:
      'トレーナーのおすすめの精度向上のために評価をお願いいたします。<br class="hidden-sm-and-down" />(今回のレッスン評価はレッスン履歴から評価をお願いいたします)',
    lessonCountLabel: '受講回数',
    trainerFeatures: 'トレーナーの特徴',
    studentFeatures: 'あなたが設定したレッスンの要望',
    note1: '※「レッスンの要望」はMyBizmatesの「お客様設定」から変更することができます。',
    note2: '※トレーナーについての評価は「レッスン履歴」から後で評価することはできません。'
  },
  recommendedTrainerTimeSetting: {
    configuration: '設定',
    error1: '受講時間帯設定の値に誤りがあります。',
    error2: '再設定をお願いします。',
    endingTime: '終了時間',
    startTime: '開始時間',
    heading: 'レッスン受講を習慣化するための時間帯設定',
    subtext1: 'あらかじめレッスンを受ける時間帯を決めておくと、習慣化しやすくなります。',
    subtext2: '設定した時間帯に予約できるトレーナーをおすすめします。'
  },
  bookingConfirmation: {
    lessonReservation: 'レッスン予約',
    reservationCompleted: 'レッスンの予約が正しく完了いたしました。',
    checkReservationStatus: 'レッスンの予約状況はトップページからご確認いただけます。',
    continueBookingWithSameTrainer: '同じトレーナーで続けて予約する',
    closeUp: '閉じる',
    error: '予約が出来ませんでした。再度、予約手続きをお願いいたします。'
  },
  audio: {
    play: '自己紹介を再生'
  },
  favorites: {
    addToFavoritesListLabel: 'お気に入りリストに登録',
    addNewFavorites: 'お気に入りリストを作成する',
    existingFavorites: 'リストに追加しました',
    errorExistingFavorites: 'お気に入りリストエラー',
    charactersLeft: '残<span class="count">{0}</span>文字',
    createNote1: 'トレーナーのお気に入りリストを10個まで設定できます。',
    createNote2: 'リストを入力してお気に入りリストを作成してください。',
    successMessage: '{0} に追加されました。',
    errors: {
      blank: 'お気に入りリスト名は空白にできません。'
    }
  },
  bookingMain: {
    button: {
      confirm: 'この内容で確認',
      book: '予約を確定する',
      previous: '戻る',
      close_up: '閉じる'
    },
    header: 'レッスン予約',
    note: {
      text1: '＜ご注意ください＞',
      text2: '※30分以内に予約したレッスンはキャンセルすることができません。',
      text3:
        '※12:00AM以降のレッスンを予約した際のレッスン日時について、日付は翌日に切り替わっていますが、Bizmatesでは前日分のレッスンとして扱われます。'
    },
    program_title: 'ご希望のレッスンタイプ・教材をお選びください。',
    other_program: {
      header: '教材を選択する',
      content: '特定スキルの習得にフォーカスされた教材をつかって学習します。',
      recent: '前回と同じ教材を選択する'
    },
    assist_lesson: {
      content:
        'プレゼンの予行練習、英文メールの添削等、受講生の直近のビジネスの課題を解決するためのレッスンを行います。'
    },
    bizmates_program: {
      content:
        'Bizmatesのコアプログラム。レベルに合った教材をつかって段階的かつ体系的に学習します。'
    },
    discovery: {
      content:
        '様々な題材のエッセイからお好きなものを選び、トレーナーと異文化ディスカッションを行います。',
      category_button: {
        submit: '設定する'
      },
      categories: {
        header: '条件を絞り込む',
        title: 'カテゴリー'
      },
      header1: '教材記事検索して選択',
      header2: 'お気に入りから選択',
      form: {
        like_flg: 'お気に入りのみ',
        book_flg: '未受講の教材記事のみ',
        showCategory: 'カテゴリー',
        selectedCategories: '選択中のカテゴリー：',
        freeWord: 'フリーワード',
        discovery_free_word: '教材記事のタイトル・教材記事の作者名',
        search_discovery_article_id: '教材記事番号',
        searchMaterial: '教材記事を検索する',
        searchAll: '教材記事一覧'
      },
      noDataDescription: '教材記事をお気に入りに登録しておくと、ここから選択できるようになります。',
      selectArticle: 'この教材記事を選択'
    },
    close: {
      header: 'レッスン予約',
      text1: '予約が確定していません。',
      text2: '本当に終了してよろしいですか？',
      button: {
        close: '終了してウィンドウを閉じる',
        continue: '予約画面に戻る'
      }
    }
  },
  cfe: {
    notif: 'トレーナーが退室しました',
    title: 'レッスンの評価を入力してください',
    subtitle: 'レッスンの品質向上のため、下記評価を\nお願いいたします。',
    submit: '送信',
    q1veryBadReason: '今回『非常に悪い』を選択された理由をお聞かせください',
    q1badReason: '今回『悪い』を選択された理由をお聞かせください',
    q4veryBadReason: '今回『受けたくない』を選択された理由をお聞\nかせください',
    q4badReason: '今回『受けたいと思わない』を選択された理由をお聞かせください',
    reasonMaxLength: '1000以内で入力',
    requiredLabel: '＊は必須です',
    hideTrainer: {
      title: 'このトレーナーを\n予約画面に表示しないようにしますか?',
      subtitle: 'これから予約画面にこのトレーナーを表示しません。\nこの設定はレッスン履歴ページから変更できます。',
      showTrainer: 'トレーナーを表示する',
      doNotShowTrainer: 'トレーナーを表示しない'
    },
    confirmation: {
      title: 'レッスンの評価を送信しました',
      subtitle: 'ご回答ありがとうございました。',
      close: '閉じる',
      book: 'レッスンを予約する'
    }
  }
};

export default { mbti };
